import Swiper from 'swiper';

export default class Leaders {
	constructor(el) {
		this.el = el;
		this.sliderEl = this.el.querySelector('.leaders__slider');
		this.slides = [...this.sliderEl.querySelectorAll('.leader')];
		this.closeBtn = this.el.querySelector('.leaders__overlay__close');
		this.overlay = this.el.querySelector('.leaders__overlay');
		this.modals = [...this.el.querySelectorAll('.leader-modal')];

		this.html = document.querySelector('html');

		this.init();
		this.events();
	}

	init() {
		this.total = this.slides.length;

		this.slider = new Swiper(this.sliderEl, {
			slidesPerView: 'auto',
			spaceBetween: 15,
			centeredSlides: true,
			slideActiveClass: 'leader--active',
			initialSlide: Math.floor((this.total - 1) / 2),
			threshold: 10,
			effect: 'coverflow',
			grabCursor: true,
			coverflowEffect: {
				rotate: 0,
				stretch: 0,
				depth: 0,
				modifier: 1,
				slideShadows : false
			},
			pagination: {
				el: '.slider__pagination',
				clickable: true,
				bulletClass: 'slider__bullet',
				bulletActiveClass: 'slider__bullet--active'
			},
			breakpoints: {
				480: {
					//initialSlide: 0,
					spaceBetween: 10
				}
			}
		});

		this.updateSlides();
	}

	events() {
		this.slides.forEach((slide, i) => {
			slide.addEventListener('click', e => {
				e.preventDefault();
				this.slideClickHandle(slide, i);
			});
		});

		this.closeBtn.addEventListener('click', this.close.bind(this));
		this.overlay.addEventListener('click', e => {
			if (e.target === this.overlay) {
				this.close();
			}
		});

		this.slider.on('slideChange', () => {
			this.updateSlides();
		});
	}

	updateSlides() {
		let current = this.slider.realIndex;
		this.resetSlides();

		this.slides.forEach((el, i) => {
			if (i < current) {
				el.classList.add('leader--prev');
			} else if (i > current) {
				el.classList.add('leader--next');
			}
		});
	}

	resetSlides() {
		this.slides.forEach(el => {
			el.classList.remove('leader--prev');
			el.classList.remove('leader--next');
		});
	}

	slideClickHandle(slide, i) {

		if (this.slider.realIndex != i) {
			this.slider.slideTo(i);
		} else {
			this.openModal(slide);
		}

	}

	openModal(slide) {
		const id = slide.getAttribute('data-leader-id');
		const modal = this.el.querySelector(`.leader-modal[data-leader-id="${id}"]`);

		if (modal) {
			this.html.classList.add('modal-open');
			this.overlay.classList.add('active');
			modal.classList.add('active');
		}
	}

	close() {
		this.html.classList.remove('modal-open');
		this.overlay.classList.remove('active');
		this.closeAllModals();
	}

	closeAllModals() {
		this.modals.forEach(modal => {
			modal.classList.remove('active');
		});
	}
}
